import {
  controlPaddingHorizontal,
  dropdownPaddingBlock,
} from '@atlas-frontend/design-tokens';
import { Upload } from 'antd';
import styled from 'styled-components';

export const DropdownUpload = styled(Upload)`
  color: inherit;
  width: 100%;
  display: block;

  .ant-upload-select {
    width: 100%;
    display: block;
    > .ant-upload {
      width: 100%;
      display: block;
      padding: ${dropdownPaddingBlock}px ${controlPaddingHorizontal}px;
    }
  }
`;
